<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight" style="background-size: cover; background-position:center; "
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div class="row">
            <div style="width:22%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:56%">
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">BLOGS &
                    MORE</h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge2" style="text-transform: uppercase;">GET
                    GROWING WITH THE <br>KNOWLEDGE YOU NEED</h1>
            </div>
            <div style="width:22%"></div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="row" style="max-width:1500px; margin:auto">
            <div class="col-lg-3 filterContainer"
                *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                <!-- left part of screen with filters -->
                <h3 CLASS="DIN2014Bold blackText mb-3"
                    style=" font-size:26px; line-height: normal; font-weight: 700; text-align: left; margin-left:25%; margin-bottom:0pt">
                    Knowledge</h3>
         <h4 CLASS="DIN2014Bold" (click)="SearchBlogsFired('all')"
                    style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-left:25%; margin-bottom:0pt">
                    ALL
                </h4>                    
                <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('Topics')"
                    style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-left:25%; margin-bottom:0pt">
                    TOPICS
                    <img *ngIf="!topicsExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                        style="cursor:pointer;float:right;margin-top:10px">
                    <img *ngIf="topicsExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                        style="cursor:pointer;float:right;margin-top:10px">
                </h4>
                <div *ngIf="topicsExpanded">
                    <div *ngFor="let row of dotComService.blogCategories" style="text-align: left; margin-left:25%;">
                        <label>
                            <input type="radio" class="checkbox-round" name="blogRadios" style="width:10px; height:10px"
                                id="{{row.Category}}" (change)="BlogCategoryRadioChanged(row.Category,$event)">
                            <h6 class="DIN2014Regular"
                                style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                                {{row.Category}}</h6>
                        </label>
                    </div>
                </div>
                <h3 class="greenBackground"
                    style="margin-left:25%;margin-top:30px; max-width:200px; text-align: center;">
                    <a href="/findrep" class="DIN2014Bold whiteText "
                        style="line-height:2; font-size:20px; font-weight: 700; text-decoration: none !important">FIND
                        YOUR REP</a>
                </h3>

            </div>
            <div class="col-lg-8" style="margin-right:4%">
                <!-- right part of screen -->
                <div class="row mb-5">
                    <div class="col-md-6 text-start">
                        <input Class="DIN2014Regular searchInputContainer" placeholder="Search Here"
                            (blur)="SearchBlogsFired()" (keyup.enter)="SearchBlogsFired()"
                            [(ngModel)]="this.dotComService.blogSearchKey">
                        <img src="{{this.pageImagePaths + 'search-normal.png'}}" alt="Search Icon"
                            style="cursor:pointer;display:inline;margin-left:-30px">

                        <img *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                            src="{{baseImagePaths + 'FilterIconDark.png'}}"
                            style="cursor:pointer; width:60px; height:40px; position:absolute; right:10px"
                            alt="filter icon" (click)="ToggleFilter()">


                        <div class="col-lg-3 filterContainer"
                            *ngIf="showFilterObjects && myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && (myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                            <!-- left part of screen with filters -->
                            <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('Topics')"
                                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-left:25%; margin-bottom:0pt; margin-top:50px; padding-right:30%">
                                PRODUCTS
                                <img *ngIf="!topicsExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}"
                                    alt="arrow down" style="cursor:pointer;float:right;margin-top:10px">
                                <img *ngIf="topicsExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}"
                                    alt="arrow down" style="cursor:pointer;float:right;margin-top:10px">
                            </h4>
                            <div *ngIf="topicsExpanded">
                                <div *ngFor="let row of dotComService.blogCategories"
                                    style="text-align: left; margin-left:25%;">
                                    <label>
                                        <input type="radio" class="checkbox-round" name="blogRadios"
                                            style="width:10px; height:10px"
                                            (change)="BlogCategoryRadioChanged(row.Category,$event)">
                                        <h6 class="DIN2014Regular"
                                            style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                                            {{row.Category}}</h6>
                                    </label>
                                </div>
                            </div>
                            <h3 class="greenBackground"
                                style="margin-left:25%;margin-top:30px; max-width:200px; text-align: center;">
                                <a href="/findrep" class="DIN2014Bold whiteText "
                                    style="line-height:2; font-size:20px; font-weight: 700; text-decoration: none !important">FIND
                                    YOUR REP</a>
                            </h3>

                        </div>





                    </div>
                    <div class="col-md-6"></div>
                </div>
                <div class="row mt-3 pb-5" style="cursor: pointer; border-bottom:solid 1px grey" *ngIf="!hasFilters"
                    (click)="GoToBlog(this.featuredPost)">
                    <div class="featuredBlogContainer">
                        <img style="width:100%;height:100%;min-height:270px;object-fit: cover;"
                            src={{this.featuredPost.ImageName}} alt="post image">
                    </div>
                    <div class="featuredBlogTextContainer">
                        <h2 class="DIN2014Bold" style="font-size:26px">FEATURED RESOURCE:</h2>
                        <h3 class="DIN2014Bold" style="font-size:26px" [innerHTML]="this.featuredPost.Title"></h3>
                        <h4 class="DIN2014Regular" style="font-size:16px; opacity:0.5">
                            {{this.featuredPost.RevisionAuthor}}</h4>
                        <h5 class="DIN2014Regular line-clamp" style="font-size:19px; line-height: 27px; opacity:0.5">
                            {{this.featuredPost.Summary}}
                        </h5>
                        <h5 class="DIN2014Regular greenText"
                            style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </div>
                </div>

                <div class="row pb-5" style="border-bottom:solid 1px grey" *ngIf="!hasFilters">
                    <h2 class="DIN2014Bold" style="font-size:26px;margin-top:40px; margin-bottom:40px">Other Featured
                        Resources</h2>
                    <div class="otherFeaturedBlogContainer" (click)="GoToBlog(this.otherFeaturedPost1[0])"
                        style="cursor:pointer">
                        <img class="featuredBlogImage" src={{this.otherFeaturedPost1[0].ImageName}} alt="post image">
                        <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                            FEATURED RESOURCE:</h2>
                        <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                            [innerHTML]="this.otherFeaturedPost1[0].Title"></h3>
                        <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px; opacity:0.5">
                            {{this.otherFeaturedPost1[0].RevisionAuthor}}</h4>
                        <h5 class="DIN2014Regular greenText"
                            style="margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </div>
                    <div class="otherFeaturedBlogContainer" (click)="GoToBlog(this.otherFeaturedPost2[0])"
                        style="cursor:pointer">
                        <img class="featuredBlogImage" src={{this.otherFeaturedPost2[0].ImageName}} alt="post image">
                        <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                            FEATURED RESOURCE:</h2>
                        <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                            [innerHTML]="this.otherFeaturedPost2[0].Title"></h3>
                        <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px; opacity:0.5">
                            {{this.otherFeaturedPost2[0].RevisionAuthor}}</h4>
                        <h5 class="DIN2014Regular greenText"
                            style="margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </div>
                    <div class="otherFeaturedBlogContainer" (click)="GoToBlog(this.otherFeaturedPost3[0])"
                        style="cursor:pointer">
                        <img class="featuredBlogImage" src={{this.otherFeaturedPost3[0].ImageName}} alt="post image">
                        <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                            FEATURED RESOURCE:</h2>
                        <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                            [innerHTML]="this.otherFeaturedPost3[0].Title"></h3>
                        <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px; opacity:0.5">
                            {{this.otherFeaturedPost3[0].RevisionAuthor}}</h4>
                        <h5 class="DIN2014Regular greenText"
                            style="margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </div>
                </div>
                <div class="mb-5">
                    <!-- table of posts based on no filter ar filter applied  -->
                    <h2 class="DIN2014Bold mt-3 mb-3" style="font-size:26px;" (click)="DisplayAllResources()">All
                        Resources
                    </h2>
                    <div *ngFor="let row of this.dotComService.resourceFilteredPosts" style="text-align: left">
                        <div class="row mt-3" (click)="GoToBlog(row)" style="cursor:pointer">
                            <div class="blogGridContainer">
                                <img class="blogImage" src={{row.ImageName}} alt="post image">
                            </div>
                            <div class="blogTextContainer">
                                <h3 class="DIN2014Bold" style="font-size:19px; line-height:23px; letter-spacing: .38px;"
                                    [innerHTML]="row.Title"></h3>
                                <h4 class="DIN2014Regular"
                                    style="font-size:14px; line-height: 19px;font-weight:400; opacity:0.5">
                                    {{row.RevisionAuthor}}
                                </h4>
                                <h5 class="DIN2014Regular greenText"
                                    style="margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                                    READ ARTICLE ></h5>
                            </div>
                        </div>
                    </div>
                    <div></div>
                    <h3 *ngIf="this.disableMoreButton == false" class="lightBlueBackground"
                        style="margin-top:3%; max-width:130px; text-align: center;" (click)="GetNextGroupOfBlogs()">
                        <a class="DINNextLTPro-Black blueText "
                            style="line-height:2; font-size:20px; text-decoration: none !important">LOAD MORE</a>
                    </h3>
                </div>
            </div>
        </div>
    </div>
</div>